module.exports = __webpack_public_path__ + "a3849e815b871338b53a6abd75e2fd27.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/martin-kleppe.jpg
// module id = 518
// module chunks = 0